"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Stats = void 0;

var Stats =
/** @class */
function () {
  function Stats(meta) {
    this.$meta = meta;
  }

  Object.defineProperty(Stats.prototype, "originalRows", {
    /**
     * The number of rows in the parsed data
     */
    get: function get() {
      return this.$meta.count_rows;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Stats.prototype, "acceptedRows", {
    /**
     * The number of rows that were submitted
     */
    get: function get() {
      return this.$meta.count_rows_accepted || null;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Stats.prototype, "originalColumns", {
    /**
     * The number of columns in the parsed data
     */
    get: function get() {
      return this.$meta.count_columns || null;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Stats.prototype, "matchedColumns", {
    /**
     * The number of columns submitted
     */
    get: function get() {
      return this.$meta.count_columns_matched || null;
    },
    enumerable: false,
    configurable: true
  });
  return Stats;
}();

exports.Stats = Stats;